import { Component, OnInit, inject } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { CdsButtonModule } from '@cds/ng-web-components/button';

@Component({
  selector: 'app-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.scss'],
  imports: [CdsButtonModule],
})
export class TimeoutComponent implements OnInit {
  private authenticationService = inject(AuthenticationService);

  ngOnInit(): void {}

  loginWithSSO() {
    this.authenticationService.loginWithSSO();
  }
}
